import useAssetAmount from "./useAssetAmount";
import useCheckPortfolio from "./useCheckPortfolio";
import useCheckOrderLimits from "./useCheckOrderLimits";
import { useSelector } from "react-redux";

function useAmountLimits() {
  const {
    tradeForm: { tradeType, assetPrice },
  } = useSelector((state) => state);

  const { nativeAmount } = useAssetAmount();

  const { budget } = useCheckPortfolio();

  const { amountPrecision, minNative, maxNative } = useCheckOrderLimits();

  const maximumNativeForBuy = budget / assetPrice;
  const maximumNativeForSell = nativeAmount;

  const minimumNativeInput = minNative;

  const maximumNativeInput =
    tradeType === "sell"
      ? Math.min(maxNative, maximumNativeForSell)
      : Math.min(maxNative, maximumNativeForBuy);

  const nativeInputStep = amountPrecision;

  const minimumUsd = minimumNativeInput * assetPrice;
  const maximumUsd = maximumNativeInput * assetPrice;
  const usdInputStep = nativeInputStep * assetPrice;

  const minimumSlider = (minimumNativeInput / maximumNativeInput) * 100;
  const maximumSlider = 100;

  const sliderStep = (nativeInputStep / maximumNativeInput) * 100;
  const disableTrade = minimumNativeInput > maximumNativeInput;

  const averageNativeRange = (maximumNativeInput + minimumNativeInput) / 2;
  const averageUsdRange = (minimumUsd + maximumUsd) / 2;
  const averageSliderRange = (minimumSlider + maximumSlider) / 2;

  return {
    minimumUsd,
    maximumUsd,
    usdInputStep,
    minimumSlider,
    maximumSlider,
    sliderStep,
    disableTrade,
    minimumNativeInput,
    maximumNativeInput,
    nativeInputStep,
    averageUsdRange,
    averageNativeRange,
    averageSliderRange,
  };
}

export default useAmountLimits;
